import type React from "react";

import { AssetsService } from "app/services/AssetsService";

export const SegmentsPageLoader: React.FC = () => (
    <div className="sw_loader loading">
        <img
            src={AssetsService.assetUrl("/images/section-loader.gif")}
            alt="Loading..."
        />
    </div>
);
